import React from 'react';
import Navigation from './Navigation';

const MyListingsPage = ({ 
  currentUser, 
  currentPage, 
  setCurrentPage, 
  cart, 
  products, 
  setSelectedProduct, 
  logout, 
  deleteProduct 
}) => {
  const myProducts = products.filter(p => p.sellerId === currentUser.id);

  const handleEdit = (product) => {
    setSelectedProduct(product);
    setCurrentPage('editProduct');
  };

  const handleDelete = (productId, productTitle) => {
    if (window.confirm(`Are you sure you want to delete "${productTitle}"?`)) {
      deleteProduct(productId);
    }
  };

  return (
    <div className="container">
      <div className="header">
        <h1>🌱 EcoFinds</h1>
        <Navigation 
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          cart={cart}
          logout={logout}
        />
      </div>
      
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
        <h2>My Listings ({myProducts.length})</h2>
        <button onClick={() => setCurrentPage('addProduct')}>
          + Add New Product
        </button>
      </div>
      
      {myProducts.length === 0 ? (
        <div className="form">
          <p>You haven't listed any products yet.</p>
          <button onClick={() => setCurrentPage('addProduct')}>
            Create Your First Listing
          </button>
        </div>
      ) : (
        <div className="products-grid">
          {myProducts.map(product => (
            <div key={product.id} className="product-card">
              <div className="img">📷 Image Placeholder</div>
              <h3>{product.title}</h3>
              <p className="price">${product.price}</p>
              <p><strong>Category:</strong> {product.category}</p>
              <p style={{fontSize: '14px', color: '#666', marginBottom: '10px'}}>
                {product.description.substring(0, 80)}...
              </p>
              <button onClick={() => handleEdit(product)}>
                Edit
              </button>
              <button 
                className="delete" 
                onClick={() => handleDelete(product.id, product.title)}
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyListingsPage;